import { useEditorRef } from 'platejs/react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@mui/material';

import {
    EDITOR_IMAGE_TYPE,
    EDITOR_IMAGE_MAX_SIZE,
} from 'common/constants/files';
import { FileUpload } from 'common/components/ContentEditor/elements/file/FileUpload';
import { options } from 'common/components/ContentEditor/options';

import { addOrReplaceImage } from './utils';

interface IProps {
    img?: typeof options.img;
}

export const BlockMenuImage = ({ img: _img = options.img }: IProps) => {
    const editor = useEditorRef();
    const [translate] = useTranslation();

    const handleSuccess = (url: string) => {
        addOrReplaceImage(editor, url);
    };

    return (
        <FileUpload
            component={MenuItem}
            id="menu-image-upload"
            inputProps={{ accept: EDITOR_IMAGE_TYPE }}
            maxSize={EDITOR_IMAGE_MAX_SIZE}
            onSuccess={handleSuccess}
        >
            {translate('edit')}
        </FileUpload>
    );
};
